export default __webpack_public_path__ + "static/media/Print.3119462c.svg";